export default __webpack_public_path__ + "static/media/pinstripe.00c621d7.jpg";